import React, { useState } from 'react'
import { LocalizationContextType } from '../../shared/contexts'
import SensorFormModal, { SensorTypeOption } from './SensorFormModal'

interface CreateSensorButtonProps {
  sensorTypes: SensorTypeOption[]
  localization_context?: LocalizationContextType
}

const CreateSensorButton: React.FC<CreateSensorButtonProps> = ({
  sensorTypes,
  localization_context: localizationContext
}) => {
  const [showCreate, setShowCreate] = useState(false)

  return (
    <>
      {showCreate && (
        <SensorFormModal
          sensorTypes={sensorTypes}
          localizationContext={localizationContext}
          onClose={() => setShowCreate(false)}
          onSaved={() => window.location.reload()}
        />
      )}
      <button
        type="button"
        className="btn btn-primary"
        style={{ whiteSpace: 'nowrap' }}
        onClick={() => setShowCreate(true)}
      >
        Add sensor
      </button>
    </>
  )
}

export default CreateSensorButton
